__turbopack_context__.v({
  "item": "MobileMenu-module-scss-module__bLDuGq__item",
  "item__link": "MobileMenu-module-scss-module__bLDuGq__item__link",
  "languageLabel": "MobileMenu-module-scss-module__bLDuGq__languageLabel",
  "languagesMenu": "MobileMenu-module-scss-module__bLDuGq__languagesMenu",
  "mobileMenu": "MobileMenu-module-scss-module__bLDuGq__mobileMenu",
  "nav": "MobileMenu-module-scss-module__bLDuGq__nav",
  "settings": "MobileMenu-module-scss-module__bLDuGq__settings",
  "settingsMenu": "MobileMenu-module-scss-module__bLDuGq__settingsMenu",
});
